import styled from "styled-components";

export const StyledButtonContainer = styled.div<{ $padding?: string }>`
    margin-top: auto;
    padding: ${({ $padding }) => ($padding ? $padding : "16px")};
`;
